import { render, staticRenderFns } from "./segmentedControl.vue?vue&type=template&id=249b3663"
import script from "./segmentedControl.vue?vue&type=script&lang=ts"
export * from "./segmentedControl.vue?vue&type=script&lang=ts"
import style0 from "./segmentedControl.vue?vue&type=style&index=0&id=249b3663&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports